import { TrackingProperties } from '~/utils/tracking'

export type FeatureCardType = 'published' | 'splitsConnect'

type FeatureCardSurface = 'sidebarCard'

export const FEATURE_DISCOVERY_EVENTS = {
  VIEWED_FEATURE_CARD: 'viewedFeatureCard',
  CLICKED_FEATURE_CARD: 'clickedFeatureCard',
  DISMISSED_FEATURE_CARD: 'dismissedFeatureCard',
} as const

// user is global (Amplitude identify), so only orgId is passed
export type FeatureCardTracking = {
  cardId: string
  cardName: string
  cardType: FeatureCardType
  orgId?: string
}

export const featureCardClickProperties = (
  tracking: FeatureCardTracking,
  surface: FeatureCardSurface,
): TrackingProperties => ({ ...tracking, surface })
